/* Align only the desktop logo to the existing text column, never move the column. */
class MonolytFooterLogo extends HTMLElement {
  connectedCallback() {
    this.cleanup?.();
    const footer = this.parentElement?.querySelector('.footer-content');
    const heading = footer?.querySelector('.monolyt-footer-nav__heading');
    if (!heading) return;

    const desktop = window.matchMedia('(min-width: 750px)');
    let active = true;
    let frame = 0;
    const measure = () => {
      frame = 0;
      if (!active || !this.isConnected) return;
      if (!desktop.matches) {
        this.style.removeProperty('--footer-logo-start');
        return;
      }
      const band = this.getBoundingClientRect();
      const text = heading.getBoundingClientRect();
      if (band.width <= 0 || text.width <= 0) return;
      const start = `${Math.max(0, text.left - band.left)}px`;
      if (this.style.getPropertyValue('--footer-logo-start') !== start) {
        this.style.setProperty('--footer-logo-start', start);
      }
    };
    const schedule = () => {
      if (active && !frame) frame = requestAnimationFrame(measure);
    };
    const observer = new ResizeObserver(schedule);
    [this, footer, heading].forEach((element) => observer.observe(element));
    desktop.addEventListener('change', schedule);
    document.fonts?.ready.then(schedule);
    schedule();

    this.cleanup = () => {
      active = false;
      observer.disconnect();
      cancelAnimationFrame(frame);
      desktop.removeEventListener('change', schedule);
      this.style.removeProperty('--footer-logo-start');
    };
  }

  disconnectedCallback() {
    this.cleanup?.();
  }
}

if (!customElements.get('monolyt-footer-logo')) {
  customElements.define('monolyt-footer-logo', MonolytFooterLogo);
}
